<template>
  <ContentBannerList>
    <template v-for="(banner, index) in contentBanners">
      <Banner 
        :key="banner.id"
        v-bind="{ ...banner }"
        @click="trackContentBannerClicked(index, banner.url)"
      />
    </template>
  </ContentBannerList>
</template>

<script>
import { mapGetters } from 'vuex'
import ContentBannerList from './ContentBannerList.vue'
import Banner from './Banner.vue'
import impressionTracking from '@sephora-asia/common-ui/mixins/impressionTracking.js'

export default {
  name: 'ContentBannerListContainer',

  components: {
    ContentBannerList,
    Banner
  },

  mixins: [impressionTracking],

  head() {
    return {
      // Improve page load speed with preconnect
      // https://web.dev/uses-rel-preconnect/#improve-page-load-speed-with-preconnect
      link: [
        {
          rel: 'preconnect',
          href: process.env.ASSET_HOST,
          crossorigin: true
        }
      ]
    }
  },

  computed: {
    ...mapGetters({
      contentBanners: 'billboard/contentBanners'
    })
  },

  methods: {
    trackContentBannerClicked(index, bannerUrl) {
      const params = {
        content_banner_position: index + 1,
        content_banner_url: bannerUrl
      }
      this.$analytics.trackEvent('homepage_click_content_banner', { params })
    },
    trackImpression() {
      this.$analytics.trackEvent('homepage_impression_content_banner')
    }
  }
}
</script>
